
import React from "react";

// reactstrap components
import {
  Card,
  CardBody,
  CardTitle,
  CardText,
  Container,
  Row,
  Col
} from "reactstrap";
// core components
import SimpleHeader from "../../../../components/Headers/SimpleHeader";
import VideoPlayer from '../../../../components/VideoPlayer/VideoPlayer';
import connect from 'redux-connect-decorator';
import { getTutorials } from '../../../../actions/tutorialActions';
import { LockContent } from '../../components/LockContent';
import { isFreeUser } from '../../../../utils/ccl-utils';
import { getUserInfo } from '../../../../actions/authActions';

@connect(
  state => ({
    tutorials: state.tutorial.tutorials,
    loading: state.tutorial.loading,
    isFreeUser: isFreeUser(state.auth.user.authorities),
    user: state.auth.user
  }),
  {
    getTutorials,
    getUserInfo
  }
)
class Tutorial extends React.Component<any, any> {
  state = {
    // video: {
    //     src: "https://s3-ap-southeast-2.amazonaws.com/cclmagic.com.au/video_1.mp4",
    //     poster: "https://s3-ap-southeast-2.amazonaws.com/cclmagic.com.au/video_1.png"
    // }
  }

  componentDidMount() {
    this.props.getTutorials();
    this.props.getUserInfo();
  }

  render() {
    const { tutorials, isFreeUser, user } = this.props;
    return (
      <>
        <SimpleHeader name="Tutorial" parentName="Tutorial" />
        <Container className="mt--6 lock-container" fluid>
          <Row className="card-wrapper">
            { isFreeUser && <LockContent /> }
            {tutorials && tutorials.map((item, i) => (
              <Col lg="6" key={`col-video-player-${i}`}>
                <Card>
                  <CardBody>
                    <CardTitle className="mb-3" tag="h3">
                      { item.title }
                    </CardTitle>
                    <div className="mb-4">
                      <VideoPlayer key={`video-player-${i}`} {...item} />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </>
    );
  }
}

export default Tutorial;
